import BasicRouterView from "../../components/BasicRouterView.vue";

const configuracaoRoutes = {
  path: "config",
  redirect: { name: "centrodecusto-listar" },
  meta: {
    label: "Configuração",
    icon: "settings",
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "configuracao/listar-alertas",
      name: "configuracao-listarAlertas",
      meta: {
        label: "Listar Alertas",
        icon: "list",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "centrodecusto" */ "./views/ListarAlertas.vue"
        ),
    },
    {
      path: "configuracao/lista-logs",
      name: "configuracao-logs-lista",
      meta: {
        label: "Lista de Logs",
        icon: "settings",

        show: true,
      },
      component: () => import(/* webpackChunkName: "pdt" */ "./views/Logs.vue"),
    },
    {
      path: "configuracao/lista-notificacao",
      name: "configuracao-logs-lista-notificacao",
      meta: {
        label: "Lista de Logs Notificação",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/LogsNotificacao.vue"),
    },
    {
      path: "configuracao/lista-logs-planilha",
      name: "configuracao-logs-lista-planilha",
      meta: {
        label: "Lista de Logs Planilhas",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/LogsPlanilhas.vue"),
    },
  ],
};

export default configuracaoRoutes;
